import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IUserStore } from '../../../../__legacy__/modules/user/user.store';
import { ICursorControlBl } from '../CursorControl.bl';
import { CursorGuidesCheckbox } from './CursorGuidesCheckbox';

interface IProps {
  disabled: boolean;
}

export const CursorGuidesCheckboxContainer = observer((props: IProps): ReactElement => {
  const bl = useInjection(ICursorControlBl.$);
  const userStore = useInjection(IUserStore.$);

  const handleChange = (): void => {
    bl.toggleCursorGuides();
  };

  return (
    <CursorGuidesCheckbox
      disabled={props.disabled}
      checked={userStore.areCursorGuidesEnabled}
      onChange={handleChange}
    />
  );
});
